import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import { ScrollToPlugin } from 'gsap/dist/ScrollToPlugin'

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(ScrollToPlugin)

class HeroVideo {
    constructor(root) {
        this.root = root;
        this.video = this.root.querySelector('[data-hero-video--video]');
        this.indicator = this.root.querySelector('[data-hero-video--indicator]');

        this.bind();
        this.init();
    }

    bind() {
        this.onClick = this.onClick.bind(this);
        this.indicator.addEventListener('click', this.onClick);
    }

    unbind() {
        this.indicator.removeEventListener('click', this.onClick);
    }

    onClick() {
        const y = this.root.offsetTop + this.root.getBoundingClientRect().height

        gsap.to(window, {
            duration: 1.3,
            scrollTo: y,
            ease: 'out',
        });
    }

    init() {
        this.anim = gsap.timeline({
            scrollTrigger: {
              trigger: this.root,
              start: 'top 90%',
              end: 'bottom 10%',
              invalidateOnRefresh: true,
              // markers: true,
            },
        });

        this.anim.fromTo(this.root, {
            opacity: 0,
        }, {
            opacity: 1,
            duration: 0.3,
            ease: 'out',
        });

        this.anim.fromTo(this.indicator, {
            opacity: 0,
            xPercent: -30,
        }, {
            opacity: 1,
            xPercent: 0,
            delay: 1.3,
            duration: 0.3,
            ease: 'out',
        });


        this.video.play();
    }

    destroy() {
        this.unbind();
        this.anim && this.anim.kill();
    }
}

export default {
    when() {
        return document.querySelectorAll('[data-hero-video]').length > 0
    },

    created() {
        this.instances = [];
        document.querySelectorAll('[data-hero-video]').forEach(root => {
            const instance = new HeroVideo(root)
            this.instances.push(instance);
        })
    },

    destroyed() {
        this.instances.forEach(instance => {
            instance.destroy && instance.destroy();
        });
    }
}
